import * as React from "react";
import {QuotePartsPriceStrategy} from "../../../model/quote/Quote";

interface Props {
	partsPriceStrategy: string
}

export const PriceStrategyPresenter: React.SFC<Props> = (props) => {
	return <div className={'c-quote-strategy-presenter'}>
		{`${props.partsPriceStrategy === QuotePartsPriceStrategy.BEST_AVAILABILITY ? "Best availability price" : "Lowest price"}`}
	</div>
}
